export default {
  id: 'molten.UserPositionSymbol',
  name: 'userPosition',
  src: 'https://storage.googleapis.com/molten-ui-assets/user-location.png',
  width: 48,
  height: 48
};